angular.module('agreements')
    .component('agreementOfferList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/agreements/offer/list-offer.html',
        controller: function ($scope, $state, $stateParams, Agreement, AgreementService, AgreementOfferService, AgreementConst, InvoiceService, TableSelection) {
            this.AgreementService = AgreementService
            this.AgreementOfferService = AgreementOfferService
            this.types = AgreementService.getTypes('OFFER')
            this.pricingSummaryProperties = ['net', 'gross']
            this.reset = () => this.filters = {}
            this.$onInit = () => {
                this.selection = TableSelection.create(this.page.list, selected => {
                    this.statistics.selected = InvoiceService.sumInvoicesByCurrency(selected.map(item => ({currency: item.currency, pricing: item})))
                })
            }
            $scope.$on(AgreementConst.eventUpdate, () => $state.reload())
            $scope.$on("file.saved", () => $state.reload())
        }
    })
